var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from '@ember-data/model';
import { isNone } from '@ember/utils';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import ALMOST_MAX_VALUE from '@square/dashboard-utilities/utils/math/almost-max-value';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import Money from '@square/dashboard-money/models/money';
import { alias, mapBy } from '@ember/object/computed';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line unused-imports/no-unused-imports

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line unused-imports/no-unused-imports

import { tracked } from '@glimmer/tracking';

// Creates an ItemModifierOption model object that will be defined to use Cogs API or new Merchant Catalog API
// depending upon how the user's merchant catalog feature flag is set
let ItemModifierOption = (_dec = attr('string'), _dec2 = attr('string-empty-to-null'), _dec3 = attr('legacy-money'), _dec4 = attr('number'), _dec5 = attr('boolean', {
  defaultValue: false
}), _dec6 = attr('boolean', {
  allowNull: true
}), _dec7 = belongsTo('item-modifier-list', {
  async: false
}), _dec8 = fragmentArray('object-image-membership', {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - this is a custom option for items-v3-base
  relatedType: 'connect/image'
}), _dec9 = mapBy('imageMemberships', 'image'), _dec10 = alias('images.firstObject'), _class = (_class2 = class ItemModifierOption extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor2, this);
    _initializerDefineProperty(this, "price", _descriptor3, this);
    _initializerDefineProperty(this, "ordinal", _descriptor4, this);
    _initializerDefineProperty(this, "hiddenOnline", _descriptor5, this);
    _initializerDefineProperty(this, "onByDefault", _descriptor6, this);
    _initializerDefineProperty(this, "modifierList", _descriptor7, this);
    _initializerDefineProperty(this, "imageMemberships", _descriptor8, this);
    _initializerDefineProperty(this, "images", _descriptor9, this);
    _initializerDefineProperty(this, "primaryImage", _descriptor10, this);
    _initializerDefineProperty(this, "isPlaceholder", _descriptor11, this);
  }
  static catalogType() {
    return 'ITEM_MODIFIER_OPTION';
  }
  static createPlaceholder(store, modifierList = null, globallyEnabled = false) {
    const placeholder = store.createRecord('item-modifier-option', {
      ordinal: ALMOST_MAX_VALUE,
      isPlaceholder: true,
      onByDefault: false,
      hiddenOnline: false,
      // NOTE(tbook): This ensures we have the correct formatter despite not having a value. Otherwise
      // JP prices will gain 2 decimal points on save (see CATALOG-6).
      price: Money.fromCents(null)
    });
    placeholder.set('globallyEnabled', globallyEnabled);
    if (!isNone(modifierList)) {
      placeholder.setMerchantSubunits(modifierList.get('subunitsPlusEnabledUnits'), undefined, modifierList.get('disabledUnits'));
    }
    return placeholder;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'item-modifier-option'), _defineProperty(_class2, "sortKey", 'name'), _defineProperty(_class2, "currentUserAffectsEnabledUnitsAll", void 0), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "kitchenName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "hiddenOnline", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "onByDefault", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "modifierList", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "imageMemberships", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "images", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "primaryImage", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "isPlaceholder", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { ItemModifierOption as default };